import axios from "axios";
import React, { FunctionComponent, useEffect, useState } from "react";
import { renderRating, Section_Click } from "../../../utils/utils";
import { InteractiveResult } from "../SearchListing/InteractiveResult";
import Picture from "../SearchListing/Picture";
import "../SearchListing/scss/Product.scss";

const Product: FunctionComponent<any> = (props) => {
  let products = props.dataMagento;
  let result = props.result;
  let resultItemColorUnique: any = [];
  const [indexVariant, setIndexVariant] = useState(-1);
  const [renderedVariant, setRenderedVariant] = useState(result);
  const [isFilteredVariant, setIsFilteredVariant] = useState(false);

  // Loop the list of child to get the list of variant to display in search result
  if (result.childResults?.length > 1) {
    //Filter childResult have color.
    resultItemColorUnique = result.childResults.filter(
      (childResult: any) => !!childResult.additionalFields.color
    );
    // Add variant outside of childResult to the variantList to ensure it always displays in the UI
    if (result.additionalFields.color && result.additionalFields.objecttype === "Variant") {
      resultItemColorUnique.push(result);
    }
  }

  // Data from Coveo
  let [resultItemProduct, setResultItemProduct] = useState({
    rating: result.additionalFields.bv_avg_product_rating === 0 || result.additionalFields.bv_avg_product_rating ? result.additionalFields.bv_avg_product_rating : "",
    numberOfPreview:
      result.additionalFields.bv_number_of_reviews === 0 ||
      result.additionalFields.bv_number_of_reviews
        ? result.additionalFields.bv_number_of_reviews
        : "",
    pdpPage: result.additionalFields.product_url ? result.additionalFields.product_url : "",
    childProduct: result.additionalFields.product_url
      ? result.additionalFields.product_url
      : "",
    productName: result.additionalFields.title ? result.additionalFields.title : "",
    productImage: result.additionalFields?.thumbnail ? result.additionalFields.thumbnail : "",
    productBadge: result.additionalFields.product_badges
      ? result.additionalFields.product_badges
      : "",
    productHighlight: result.additionalFields.description
      ? result.additionalFields.description
      : "",
    basePrice: result.additionalFields.base_price ? result.additionalFields.base_price : "",
    color: result.additionalFields.color ? result.additionalFields.color : "",
    oosl: result.additionalFields.retired_product
      ? result.additionalFields.retired_product.toLowerCase()
      : "",
    variants: result.childResults ? resultItemColorUnique : [{}],
    isDiscontinuedProduct: false
  });

  // Data from Magento
  let [resultItemMagento, setResultItemMagento] = useState({
    finalPrice: "",
    stock_status: "",
    free_shipping: "",
    free_shipping_label: "",
    discontinued_product: "",
    special_offers: []
  });

  useEffect(() => {
    if (products.length > 0) {
      for (let index = 0; index < products.length; index++) {
        const product = products[index];
        if (
          product.sku === result.additionalFields.sku && (
          product.eight_digits_sku === product.sku ||
          resultItemProduct.variants?.length < 1)
        ) {
          resultItemColorUnique = resultItemProduct.variants.filter(
            (variant: any) =>
              variant.additionalFieldsmerchandise_type === result.additionalFields.merchandise_type
          );
          baseSetResultItemProduct(result, resultItemColorUnique, product.discontinued_product);
          baseSetResultMagentoProduct(product);
        } else {
          if (resultItemProduct.variants?.length > 1) {
            const matchVariant = resultItemProduct.variants.find(
              (variant: any) =>
                variant.additionalFieldseight_digits_sku === product.eight_digits_sku
            );
            if (matchVariant) {
              resultItemColorUnique = resultItemProduct.variants.filter(
                (variant: any) =>
                  variant.additionalFieldsmerchandise_type === matchVariant.additionalFields.merchandise_type
              );
              baseSetResultItemProduct(matchVariant, resultItemColorUnique, product.discontinued_product);
              baseSetResultMagentoProduct(product);
              setRenderedVariant(matchVariant);
            }
          }
        }
      }
    }
  }, [products]);
  
  function getElementIndex(el: any) {
    return [...el.parentElement.children].indexOf(el);
  }

  async function getMagentoData(e: any) {
    let index = getElementIndex(e.target);
    setIndexVariant(index);
    const domain = `${
      (window.location.hostname === "localhost"
        ? "https://www.webtest.usa.canon.com"
        : window.location.origin) + "/shop/graphql?"
    }`;
    let query = `query={productListInfo(skus:["${resultItemProduct?.variants[index]?.additionalFields?.sku}"]) {products{name sku product_url eight_digits_sku stock_status free_shipping free_shipping_label discontinued_product special_offer price}}}`;
    baseSetResultItemProduct(resultItemProduct?.variants[index], resultItemProduct.variants, resultItemProduct.isDiscontinuedProduct);
    axios.get(`${domain + query}`).then((res) => {
      baseSetResultMagentoProduct(res.data.data?.productListInfo?.products[0]);
    });
  }

  function baseSetResultItemProduct(displayResultCoveo: any, variantsList: any, isDiscontinuedProduct: any) {
    setResultItemProduct({
      rating: resultItemProduct.rating,
      numberOfPreview:
        displayResultCoveo.additionalFields.bv_number_of_reviews === 0 ||
        displayResultCoveo.additionalFields.bv_number_of_reviews
          ? displayResultCoveo.additionalFields.bv_number_of_reviews
          : "",
      pdpPage: displayResultCoveo.additionalFields.product_url
        ? displayResultCoveo.additionalFields.product_url
        : "",
      childProduct: displayResultCoveo.additionalFields.product_url
        ? displayResultCoveo.additionalFields.product_url
        : "",
      productName: displayResultCoveo.additionalFields.title
        ? displayResultCoveo.additionalFields.title
        : "",
      productImage: displayResultCoveo.additionalFields?.thumbnail
        ? displayResultCoveo.additionalFields.thumbnail
        : "",
      productBadge: displayResultCoveo.additionalFields.product_badges
        ? displayResultCoveo.additionalFields.product_badges
        : "",
      productHighlight: displayResultCoveo.additionalFields.description
        ? displayResultCoveo.additionalFields.description
        : "",
      basePrice: displayResultCoveo.additionalFields.base_price
        ? displayResultCoveo.additionalFields.base_price
        : "",
      color: displayResultCoveo.additionalFields.color ? displayResultCoveo.additionalFields.color : "",
      oosl: displayResultCoveo.additionalFields.retired_product
        ? displayResultCoveo.additionalFields.retired_product.toLowerCase()
        : "",
      // variants: resultItemProduct.variants,
      variants: variantsList,
      isDiscontinuedProduct: isDiscontinuedProduct
    });
    setIsFilteredVariant(true);
  }

  function baseSetResultMagentoProduct(displayResultMagento: any) {
    setResultItemMagento({
      finalPrice: displayResultMagento?.price !== "0" ? displayResultMagento.price : "",
      stock_status: displayResultMagento
        ? displayResultMagento.stock_status
        : "",
      free_shipping: displayResultMagento
        ? displayResultMagento.free_shipping
        : "",
      free_shipping_label: displayResultMagento
        ? displayResultMagento.free_shipping_label
        : "",
      special_offers: displayResultMagento
        ? displayResultMagento.special_offer
        : "",
      discontinued_product: displayResultMagento
        ? displayResultMagento.discontinued_product
        : ""
    });
  }

  const ooslValue: HTMLInputElement | null = document.querySelector(
    "input[name=ooslPath]"
  );
  const ooslPath =
    ooslValue?.value +
    `?prodName=${encodeURIComponent(resultItemProduct.productName)}`;
  const { isSafari } = props;
  let altText: string = "";

  if (isSafari && resultItemProduct.productName?.length >= 23) {
    altText = resultItemProduct.productName.substring(0, 23) + "...";
  } else {
    altText = resultItemProduct.productName;
  }

  let inputResult;
  if (indexVariant > -1) {
    inputResult = resultItemColorUnique[indexVariant];
  }
  inputResult = inputResult ? inputResult : renderedVariant;

  return (
    <li className="product-result-list-item" key={inputResult.uniqueId}>
      <div className="product-item-info">
        <div className="product-item-photo">
          {/*<InteractiveResult*/}
            {/*sectionClick={Section_Click.SEARCH_RESULTS}*/}
            {/*isAffiliate={props.isAffiliate}*/}
            {/*product_use={true}*/}
            {/*result={inputResult}*/}
            {/*price={resultItemMagento.finalPrice}*/}
          {/*>*/}
            <a
                target={"_self"}
                href={resultItemProduct.childProduct}
            >
            {resultItemProduct.productBadge && (
              <div className="product-label">
                <div className="product-label-text">
                  {resultItemProduct.productBadge}
                </div>
              </div>
            )}
            <Picture
              pictureClass="product-image-container"
              thumbnailSrc={resultItemProduct.productImage}
              altText={altText}
              isSafari={isSafari}
              altTextTitle={resultItemProduct.productName}
              productClass="product-image-photo"
            />
            </a>
          {/*</InteractiveResult>*/}
          <div className="photo-container-footer">
            {isFilteredVariant && (
              <div className="color_picker">
              {resultItemProduct.variants?.length > 1 && (
                <span
                  key={"variant-color-" + resultItemProduct.color}
                  className={"color option " + resultItemProduct.color}
                  style={{ backgroundColor: resultItemProduct.color }}
                ></span>
              )}
              {resultItemProduct.variants?.length > 1 && (
                <>
                  <span className="color add"></span>
                  <div className="swatch-opt">
                    <div className="swatch-attribute color">
                      <div className="swatch-attribute-options clearfix">
                        {resultItemProduct.variants.map(
                          (item: any, index: any) =>
                            item.additionalFields.color && (
                              <span
                                key={"color" + index}
                                className={"color option " + item.additionalFields.color}
                                style={{ backgroundColor: item.additionalFields.color }}
                                onClick={(e) => {
                                  getMagentoData(e);
                                }}
                              ></span>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            )}
          </div>
        </div>
        <div className="product-item-detail">
          <h2 className="product-item-name">
            {/*<InteractiveResult*/}
              {/*sectionClick={Section_Click.SEARCH_RESULTS}*/}
              {/*isAffiliate={props.isAffiliate}*/}
              {/*product_use={true}*/}
              {/*result={inputResult}*/}
              {/*classList="product-item-link"*/}
              {/*price={resultItemMagento.finalPrice}*/}
            {/*>*/}
              <a
                  target={"_self"}
                  className={"product-item-link"}
                  href={resultItemProduct.childProduct}
              >
              {resultItemProduct.productName}
              </a>
            {/*</InteractiveResult>*/}
          </h2>
          <div className="product-item-review">
            <div className="inline-rating">

              {(resultItemProduct.rating === 0 ||
                resultItemProduct.rating) && (
                  <a
                      target={"_self"}
                      href={resultItemProduct.childProduct}
                  >
                    <span
                      className="stars-rating"
                      dangerouslySetInnerHTML={renderRating(
                        resultItemProduct.rating
                      )}></span>
                  </a>
                // </InteractiveResult>
              )}

            </div>
            {(resultItemProduct.numberOfPreview === 0 ||
              resultItemProduct.numberOfPreview) && (
              <div className="review-url">
                <div className="number-reviews">
                  <span>{resultItemProduct.numberOfPreview}</span>
                </div>
                  <a
                      target={"_self"}
                      href={`${resultItemProduct.pdpPage}#toreviews`}
                  >
                {/*<InteractiveResult*/}
                  {/*sectionClick={Section_Click.SEARCH_RESULTS}*/}
                  {/*isAffiliate={props.isAffiliate}*/}
                  {/*product_use={true}*/}
                  {/*result={inputResult}*/}
                  {/*reviewRedirection={`${resultItemProduct.pdpPage}#toreviews`}*/}
                  {/*price={resultItemMagento.finalPrice}*/}
                {/*>*/}
                  {resultItemProduct.numberOfPreview > 1 ? "reviews" : "review"}
                  </a>
                {/*</InteractiveResult>*/}
              </div>
            )}
          </div>
          {resultItemProduct.productHighlight?.includes("<li>") && (
            <div className="product-item-description">
              <div className="popup-product-item-description">
                <div className="popup-title-wrapper">
                  <span className="popup-title">Product Highlights</span>
                </div>
                <div
                  dangerouslySetInnerHTML={renderDescription(
                    resultItemProduct.productHighlight
                  )}
                ></div>
              </div>
              <div className="popup-product-item-summary-description">
                <ul
                  dangerouslySetInnerHTML={renderProductHighlights(
                    resultItemProduct.productHighlight
                  )}
                ></ul>
              </div>
            </div>
          )}
          {(resultItemMagento.finalPrice ||
            resultItemMagento.stock_status ||
            resultItemMagento.free_shipping ||
            resultItemMagento.special_offers?.length > 0) && (
            <div className="product-item-configuration">
              <h3>Configuration and price</h3>
            </div>
          )}
          <div className="product-item-price-stock">
              {!resultItemProduct.isDiscontinuedProduct && resultItemMagento.finalPrice && (
                <div className="price">
                  <span className="normal-price">
                    ${parseFloat(resultItemMagento.finalPrice).toFixed(2)}
                  </span>
                </div>
              )}
              {!resultItemProduct.isDiscontinuedProduct && resultItemProduct.basePrice &&
                parseFloat(resultItemProduct.basePrice) >
                  parseFloat(resultItemMagento.finalPrice) && (
                    <div className="price">
                      <span className="old-price">
                        ${parseFloat(resultItemProduct.basePrice).toFixed(2)}
                      </span>
                    </div>
                  )}
            <div className="stock-detail">
              {resultItemProduct.isDiscontinuedProduct && (
                  <div className="stock available" style={{color: "red"}}>
                    <div className="status-label">Discontinued</div>
                  </div>
              )}
              {!resultItemProduct.isDiscontinuedProduct && resultItemMagento.stock_status && (
                <div className="stock available">
                  <div className="status-label">
                    {resultItemMagento.stock_status}
                  </div>
                </div>
              )}
              {!resultItemProduct.isDiscontinuedProduct && resultItemMagento.free_shipping && (
                <div className="free-shipping">Free Shipping</div>
              )}
              {!resultItemProduct.isDiscontinuedProduct && resultItemMagento.special_offers?.length > 0 && (
                <div className="stock-special-offers">
                  <div className="offers-detail">
                    <ul className="offers-list-item"
                      onClick={(e) => {
                        var offerEle = jQuery(e.target);
                        var PDPlink = offerEle.closest(".product-item-detail").find('h2.product-item-name >a');
                        PDPlink[0].click();
                      }}>
                      {resultItemMagento.special_offers.map(
                        (special_offer: any, index: number) => {
                          if (index !== 0) {
                            return;
                          }
                          else {
                            return (
                              <li
                                key={"offer-item-" + index}
                                className="offers-item"
                                id={"li-offer-item" + index}
                              >
                                {special_offer.length > 35 ? special_offer.substring(0, 32) + "..." : special_offer}
                              </li>
                            );
                          }
                        }
                      )}
                      {resultItemMagento.special_offers.length > 1 && <li
                        className="offers-item grid-only"
                      >
                        + {resultItemMagento.special_offers.length - 1} more
                      </li>}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

const renderProductHighlights = (description: string) => {
  let productHighlight = [];
  const regexLi = "(?:<li>.*?<\\/li>)";
  const listLi = preg_match_all(regexLi, description);

  if (listLi && listLi[0]) {
    for (let i = 0; i < listLi[0].length; i++) {
      let liContent = preg_match_all(regexLi, listLi[0][i]);
      if (i < 3) {
        productHighlight.push([liContent]);
      }
    }
  }
  return { __html: productHighlight.join("") };
};

function renderDescription(description: string) {
  return { __html: description };
}

const preg_match_all = (regex: string, str: string) => {
  // @ts-ignore
  return [...str.matchAll(new RegExp(regex, "g"))].reduce((acc, group) => {
    group
      .filter((element: any) => typeof element === "string")
      .forEach((element: any, i: string | number) => {
        if (!acc[i]) acc[i] = [];
        acc[i].push(element);
      });

    return acc;
  }, [] as string[][]);
};

export default Product;
